module.exports = __webpack_public_path__ + "img/annelie-baensch.cbe98723.jpg";